<!-- Carousel Start -->
<div
  id="carouselExampleIndicators"
  class="carousel slide container-fluid p-0 mb-5"
  data-bs-ride="carousel"
>
  <div class="carousel-indicators">
    <button
      *ngFor="let item of items; let i = index"
      type="button"
      data-bs-target="#carouselExampleIndicators"
      [attr.data-bs-slide-to]="i"
      [class.active]="i === 0"
      [attr.aria-current]="i === 0 ? 'true' : null"
      [attr.aria-label]="'Slide ' + (i + 1)"
    ></button>
  </div>
  <div class="header-carousel carousel-inner position-relative">
    <div
      *ngFor="let item of items; let i = index"
      class="owl-carousel-item carousel-item"
      [class.active]="i === 0"
      position-relative
    >
      <img class="img-fluid" src="{{ item.images[0] }}" alt="" />
      <div
        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
        style="background: rgba(0, 0, 0, 0.2)"
      >
        <div class="container">
          <div class="row justify-content-start">
            <h2 class="display-5 text-white animated slideInDown mb-4">
              {{ item.title[this.language] }}
            </h2>
            <p
              class="fs-5 fw-medium text-white mb-4 pb-2"
              [innerHtml]="
                getShortDescription(item.description[this.language], 600)
                  | urlDetector
              "
            ></p>
          </div>
          <div class="col-10 col-lg-8 px-5 justify-content-end text-right">
            <button
              class="btn btn-primary rounded-pill py-sm-3 px-sm-5 me-3 animated"
              (click)="openArticle(item)"
            >
              {{ "read_more" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#carouselExampleIndicators"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#carouselExampleIndicators"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<!-- Carousel End -->
